export default class Tabs {
  constructor(options, callback) {
    if (options?.el) {
      this.init(options, callback)
    }
  }

  init(options, callback) {
    this.tabContainer = typeof options.el === 'string' ? document.querySelector(options.el) : options.el
    this.callback = callback
    this.activeTab = this.tabContainer.querySelector('[role="tab"][aria-selected="true"]')
    this.activeTabPanel = this.tabContainer.querySelector('[role="tabpanel"][aria-selected="true"]')
  }

  setAllTabsInactive() {
    this.tabContainer.querySelectorAll('[role="tab"]').forEach((header) => {
      header.setAttribute('aria-selected', 'false')
    })
    this.tabContainer.querySelectorAll('[role="tabpanel"]').forEach((tabPanel) => {
      tabPanel.setAttribute('aria-selected', 'false')
      tabPanel.setAttribute('tabindex', '-1')
    })
  }

  setActiveTab(header, tabPanel) {
    this.setAllTabsInactive()
    header?.setAttribute('aria-selected', 'true')
    tabPanel?.setAttribute('aria-selected', 'true')
    tabPanel?.setAttribute('tabindex', '0')
  }
}
